import { createFileRoute, redirect } from '@tanstack/react-router'
import { DistriMarketLayout } from '@/layouts/DistriMarketLayout'
import { useAuthStore } from '@/store/auth.store'

export const Route = createFileRoute('/_dm')({
  beforeLoad: () => {
    const { accessToken, activeBusiness } = useAuthStore.getState()
    if (!accessToken) throw redirect({ to: '/login' })
    if (activeBusiness?.portal_only) throw redirect({ to: '/employee' })
  },
  component: DistriMarketLayout,
})
